<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form v-on:submit.prevent="register()" enctype="multipart/form-data">
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="nama" type="text" class="form-control" placeholder="Enter Community Name" required autocomplete="fullname" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="email" type="email" class="form-control" placeholder="Enter Community Email" required autocomplete="email" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="phone" type="text" class="form-control" placeholder="Enter Community Phone Number" required autocomplete="phone" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="password" type="password" class="form-control" placeholder="Password" required autocomplete="new-password" />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="confirm_password" type="password" class="form-control" required placeholder="Repeat password" autocomplete="new-password" />
                </b-input-group>
                
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-file"></i></b-input-group-text>
                    </b-input-group-prepend>
                        <b-form-textarea id="textarea"
                        v-model="deskripsi"
                        placeholder="Enter Deskripsi "
                        :rows="3"
                        :max-rows="6">
                    </b-form-textarea>
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-address-card"></i></b-input-group-text>
                    </b-input-group-prepend>
                        <b-form-textarea id="textarea1"
                        v-model="address"
                        placeholder="Enter Community Address"
                        :rows="3"
                        :max-rows="6">
                    </b-form-textarea>
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-form-file name="fileIdentity" id="fileIdentity"  placeholder="Choose identity file..."></b-form-file>
                </b-input-group>

                <b-button type="submit" variant="success" block>Create Account</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="12">
                  already have an account ? please <router-link to="/auth">login</router-link> 
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import router from '@/router/index'
import axios from "axios"
import constant from '../../utils/constant';
export default {
  name: 'Register',
  data(){
      return {
            nama : "",
            email : "",
            phone : "",
            password : "",
            confirm_password : "",
            address:"",
            flag : '',
            messages : '',
            deskripsi : '',
      }
  },
  computed:{

  },
  watch: {

  },
  methods: {
      register()
      {
        let formData = new FormData()
        var identity = document.getElementById('fileIdentity')
        formData.append('foto', identity.files[0])
        formData.append('name', this.nama)
        formData.append('email', this.email)
        formData.append('phone', this.no_telepon)
        formData.append('password',this.password)
        formData.append('address',this.address)
        formData.append('confirm_password', this.confirm_password)
        formData.append('deskripsi', this.deskripsi)
        // console.log(formData)
        axios.post(constant._BASE_URL+"register",formData)
          .then(response => {
              console.log(response)
              localStorage.setItem(`user_token`, response.data.success['token']);
              localStorage.setItem(`user_name`, response.data.success['user_name']);
              localStorage.setItem(`user_email`, response.data.success['user_email']);
              localStorage.setItem(`user_id`, response.data.success['user_id']);
              localStorage.setItem(`user_logo`, response.data.success['user_logo']);
              localStorage.setItem(`user_isloggedIn`, true);
              this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Register Berhasil',
                  showConfirmButton: false,
                  timer: 1500
                })
              router.push({name: 'Dashboard'})
          })
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue